import React from "react";

interface MeterIconProps {
  active: boolean;
}

export default function MeterIcon({ active }: MeterIconProps) {
  const stroke = active ? "#1976d2" : "#9ca3af";
  const fill = active ? "#dbeafe" : "#f3f4f6";
  const fillLight = active ? "#eff6ff" : "#fafafa";
  const rectFill = active ? "#bfdbfe" : "#e5e5e5";
  const border = active ? "#1976d2" : "#d1d5db";

  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="10" width="48" height="36" rx="7" fill={fill} stroke={border} strokeWidth="1.5" />
      <circle cx="28" cy="30" r="11" stroke={stroke} strokeWidth="1.5" fill={fillLight} />
      <path d="M28 20v3M28 37v3M18 30h3M35 30h3" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M22.5 24.5l2 2M31.5 33.5l2 2" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M30 14l-4 7h4l-4 7" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="10" y="14" width="8" height="5" rx="1" fill={rectFill} />
      <rect x="20" y="14" width="6" height="5" rx="1" fill={rectFill} />
    </svg>
  );
}
